angular.module 'zc.commonApi'

.factory "MongoRaw", ($q, FacadeV2) ->


  class MongoRaw

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        unless query._id or query._sid
          return reject "no _id or _sid"

        FacadeV2.request "/apikeys/#{query.apikey}/raws",
          params:
            match: query
            sort: options.sort
            limit: options.limit || 1000
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MongoRaw



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_raw.service.coffee